import { render, staticRenderFns } from "./CtyxUserProtocal.vue?vue&type=template&id=6f30bc0a&scoped=true&"
import script from "./CtyxUserProtocal.vue?vue&type=script&lang=js&"
export * from "./CtyxUserProtocal.vue?vue&type=script&lang=js&"
import style0 from "./CtyxUserProtocal.vue?vue&type=style&index=0&id=6f30bc0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f30bc0a",
  null
  
)

export default component.exports